module.exports = __webpack_public_path__ + "static/media/Static-Cam.94568d3d.webp";